import { Button } from "primereact/button"
import { useState } from "react"

function App() {
  const [openIndex, setOpenIndex] = useState<number | null>(null)

  const toggleAccordion = (index: number) => {
    setOpenIndex(openIndex === index ? null : index)
  }

  return (

    <div className='flex flex-col min-h-screen'>
      <div className='flex-1 flex flex-col'>
        <div className='w-full h-8 sm:h-10 flex justify-center items-center gap-1 sm:gap-2 px-2 sm:px-4' style={{ backgroundColor: '#dc2625' }}>

          <i className="pi pi-bolt text-sm sm:text-base" style={{ color: '#f6a248' }}></i>
          <p className='m-0 font-bold text-xs sm:text-sm md:text-base' style={{ color: '#FFFFFF' }}>
            ÖZEL TÜM PAKETLERDE %75'E VARAN İNDİRİM
          </p>
        </div>

        <div className='w-full h-20 sm:h-24 flex flex-col sm:flex-row justify-between items-center gap-2 sm:gap-4 px-4 sm:px-8 md:px-12 lg:px-20 py-2 sm:py-0' style={{ backgroundColor: '#2D3967' }}>
          <div className="flex align-items-center gap-1 sm:gap-2">
            <img
              src="/Logo.svg"
              className="cursor-pointer h-10 sm:h-12 md:h-12 min-h-[40px] sm:min-h-[48px] md:min-h-[56px] w-auto"
              alt="Logo"
            />
            <span className="text-lg sm:text-xl md:text-2xl" style={{
              color: "#FFFFFF",
              marginTop: "-0.3rem"
            }}>™</span>
          </div>

          <div className='flex align-items-center gap-1 sm:gap-2'>
            <div>
              <i className="pi pi-lock text-sm sm:text-base" style={{ color: '#24c65f' }}></i>
            </div>
            <p className='m-0 font-bold text-xs sm:text-sm md:text-base m-auto' style={{ color: '#93a2b7' }}>
              Güvenli Ödeme Paneli
            </p>
          </div>
        </div>

        <div className="flex flex-col justify-center items-center px-4 sm:px-6 md:px-8 py-6 sm:py-8 md:py-10">
          <p className="m-0 text-2xl sm:text-3xl md:text-4xl font-bold text-center mb-3 sm:mb-4" style={{ color: '#2D3967' }}>Sağlınız Için En Büyük Adımı{"\u00A0"}Atın</p>
          <p className="m-0 text-sm sm:text-base text-center" style={{ color: '#8ca2c1' }}>Yıl sonuna özel kaçırılmıyacak fırsatla profesyonel fizyoterapi desteği şimdi her zamankinden daha erişilebilir</p>
        </div>

        <div className="flex flex-col md:flex-row justify-center items-stretch gap-4 sm:gap-6 md:gap-8 px-4 sm:px-6 md:px-8 pb-8 sm:pb-12 md:pb-16 mt-2 sm:mt-4 md:mt-6">
          <div className="pricing-card flex flex-col relative w-full max-w-sm mx-auto md:mx-0 md:flex-1"
            style={{
              minHeight: '28rem',
              backgroundColor: '#FFFFFF',
              borderRadius: '1rem',
              border: '1px solid #e3e9f1',
              boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}>

            <div
              className="discount-badge absolute"
              style={{
                top: '10px',
                right: '-25px',
                width: '100px',
                height: '30px',
                backgroundColor: '#ee4444',
                transform: 'rotate(45deg)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
              }}
            >
              <span
                style={{
                  color: '#FFFFFF',
                  fontWeight: 'bold',
                  fontSize: '0.75rem',
                  transform: 'rotate(-360deg)',
                  letterSpacing: '0.5px'
                }}
              >
                -%50
              </span>
            </div>

            <div className="flex flex-col p-4 sm:p-6 flex-1">
              <div className="flex flex-col gap-2">
                <p className="m-0 text-base sm:text-lg font-bold" style={{ color: '#2D3967' }}>Başlangıç Paketi</p>
                <p className="m-0 text-xs sm:text-sm" style={{ color: '#8ca2c1' }}>Denemek istiyenler için ideal</p>
              </div>

              <br />


              <p className="m-0 text-xs sm:text-sm font-bold" style={{ color: '#93a2b7', textDecoration: 'line-through' }}>₺2.500</p>
              <p className="m-0 text-2xl sm:text-3xl font-bold" style={{ color: '#2D3967' }}>₺1.250 <span className="text-xs sm:text-sm font-normal" style={{ color: '#93a2b7' }}>/ paket</span></p>

              <br />

              <div className="flex flex-col justify-center gap-3 sm:gap-4">
                <div className="check-item flex items-center gap-2">
                  <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                  <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>2 Canlı Fizyoterapist Görüntülü Seans</p>
                </div>
                <div className="check-item flex items-center gap-2">
                  <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                  <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>Kişiye Özel Egzersiz Planı</p>
                </div>
                <div className="check-item flex items-center gap-2">
                  <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                  <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>30 Günlük Kulanım Süresi</p>
                </div>
              </div>
            </div>

            <div className="p-4 sm:p-6 pt-0 mt-auto">
              <Button label="Indirimli Satın Al" className="w-full" style={{ backgroundColor: '#2D3967', color: '#FFFFFF', borderRadius: '1rem' }} />
            </div>
          </div>


          <div className="pricing-card-popular-wrapper relative w-full max-w-sm mx-auto md:mx-0 md:flex-1 flex flex-col">
            <div
              className="popular-badge absolute"
              style={{
                top: '-15px',
                left: '50%',
                transform: 'translateX(-50%)',
                backgroundColor: '#2563ea',
                padding: '0.5rem 1rem',
                borderRadius: '1rem',
                zIndex: 20,
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
                pointerEvents: 'none'
              }}
            >
              <p className="m-0 text-xs font-bold" style={{ color: '#FFFFFF' }}>
                EN POPÜLER
              </p>
            </div>

            <div className="pricing-card-popular flex flex-col relative flex-1"
              style={{
                minHeight: '28rem',
                backgroundColor: '#FFFFFF',
                borderRadius: '1rem',
                border: '2px solid #2563ea',
                boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column'
              }}>

              <div
                className="discount-badge absolute"
                style={{
                  top: '10px',
                  right: '-25px',
                  width: '100px',
                  height: '30px',
                  backgroundColor: '#ee4444',
                  transform: 'rotate(45deg)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  zIndex: 10,
                  boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
                }}
              >
                <span
                  style={{
                    color: '#FFFFFF',
                    fontWeight: 'bold',
                    fontSize: '0.75rem',
                    transform: 'rotate(-360deg)',
                    letterSpacing: '0.5px'
                  }}
                >
                  -%75
                </span>
              </div>

              <div className="flex flex-col p-4 sm:p-6 flex-1">
                <div className="flex flex-col gap-2">
                  <p className="m-0 text-base sm:text-lg font-bold" style={{ color: '#2D3967' }}>Dönüşüm Paketi</p>
                  <p className="m-0 text-xs sm:text-sm" style={{ color: '#8ca2c1' }}>Düzenli takip için en ideal seçenek</p>
                </div>

                <br />


                <p className="m-0 text-xs sm:text-sm font-bold" style={{ color: '#93a2b7', textDecoration: 'line-through' }}>₺9.000</p>
                <p className="m-0 text-2xl sm:text-3xl font-bold" style={{ color: '#2563ea' }}>₺2.550 <span className="text-xs sm:text-sm font-normal" style={{ color: '#93a2b7' }}>/ paket</span></p>

                <br />

                <div className="flex flex-col justify-center gap-3 sm:gap-4">
                  <div className="check-item flex items-center gap-2">
                    <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                    <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>10 Canlı Fizyoterapist Görüşmesi</p>
                  </div>
                  <div className="check-item flex items-center gap-2">
                    <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                    <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>Kişiye Özel Egzersiz Planı</p>
                  </div>
                  <div className="check-item flex items-center gap-2">
                    <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                    <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>Whatsapp Danışma Hattı</p>
                  </div>
                  <div className="check-item flex items-center gap-2">
                    <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                    <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>6 Ay Kulanım Hakkı</p>
                  </div>
                </div>
              </div>

              <div className="p-4 sm:p-6 pt-0 mt-auto">
                <Button label="Bu Firsatı Yakala" className="w-full" style={{ backgroundColor: '#2563ea', color: '#FFFFFF', borderRadius: '1rem' }} />
              </div>
            </div>
          </div>

          <div className="pricing-card flex flex-col relative w-full max-w-sm mx-auto md:mx-0 md:flex-1"
            style={{
              minHeight: '28rem',
              backgroundColor: '#FFFFFF',
              borderRadius: '1rem',
              border: '1px solid #e3e9f1',
              boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.1)',
              overflow: 'hidden',
              display: 'flex',
              flexDirection: 'column'
            }}>

            <div
              className="discount-badge absolute"
              style={{
                top: '10px',
                right: '-25px',
                width: '100px',
                height: '30px',
                backgroundColor: '#ee4444',
                transform: 'rotate(45deg)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 10,
                boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)'
              }}
            >
              <span
                style={{
                  color: '#FFFFFF',
                  fontWeight: 'bold',
                  fontSize: '0.75rem',
                  transform: 'rotate(-360deg)',
                  letterSpacing: '0.5px'
                }}
              >
                -%75
              </span>
            </div>

            <div className="flex flex-col p-4 sm:p-6 flex-1">
              <div className="flex flex-col gap-2">
                <p className="m-0 text-base sm:text-lg font-bold" style={{ color: '#2D3967' }}>Aktif Yaşam Planı</p>
                <p className="m-0 text-xs sm:text-sm" style={{ color: '#8ca2c1' }}>Kalıcı fark için en çok tercih edilen </p>
              </div>

              <br />


              <p className="m-0 text-xs sm:text-sm font-bold" style={{ color: '#93a2b7', textDecoration: 'line-through' }}>₺15.000</p>
              <p className="m-0 text-2xl sm:text-3xl font-bold" style={{ color: '#2D3967' }}>₺3.750 <span className="text-xs sm:text-sm font-normal" style={{ color: '#93a2b7' }}>/ paket</span></p>

              <br />

              <div className="flex flex-col justify-center gap-3 sm:gap-4">
                <div className="check-item flex items-center gap-2">
                  <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                  <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>Sınırsız Canlı Fizyoterapist Görüşmesi</p>
                </div>
                <div className="check-item flex items-center gap-2">
                  <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                  <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>Kişiye Özel Egzersiz Planı</p>
                </div>
                <div className="check-item flex items-center gap-2">
                  <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                  <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>Whatsapp Danışma Hattı</p>
                </div>
                <div className="check-item flex items-center gap-2">
                  <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                  <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>Öncelikli Destek</p>
                </div>
                <div className="check-item flex items-center gap-2">
                  <i className="pi pi-check-circle text-sm sm:text-base" style={{ color: '#2563ea' }}></i>
                  <p className="m-0 text-xs sm:text-sm" style={{ color: '#2D3967' }}>12 Ay Kulanım Hakkı</p>
                </div>
              </div>
            </div>

            <div className="p-4 sm:p-6 pt-0 mt-auto">
              <Button label="Indirimli Satın Al" className="w-full" style={{ backgroundColor: '#2D3967', color: '#FFFFFF', borderRadius: '1rem' }} />
            </div>
          </div>
        </div>


        <div className="flex flex-col justify-center items-center gap-8 px-4 sm:px-6 md:px-8 pb-8 sm:pb-12">
          <p className="m-0 text-2xl sm:text-3xl md:text-4xl font-bold text-center" style={{ color: '#2D3967' }}>Sıkça Sorulan Sorular</p>

          <div className="w-full max-w-3xl flex flex-col gap-4">
            <div className="accordion-item" style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '0.75rem',
              border: '1px solid #e3e9f1',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
              overflow: 'hidden',
              transition: 'all 0.3s ease'
            }}>
              <div
                className="accordion-header flex justify-between items-center p-4 sm:p-5 cursor-pointer"
                onClick={() => toggleAccordion(0)}
                style={{
                  backgroundColor: openIndex === 0 ? '#f8f9fa' : '#FFFFFF',
                  transition: 'background-color 0.2s ease'
                }}
              >
                <p className="m-0 text-base sm:text-lg font-bold" style={{ color: '#2D3967' }}>
                  Ödeme sonrası seanslar ne zaman tanımlanır?
                </p>
                <i
                  className={`pi ${openIndex === 0 ? 'pi-chevron-up' : 'pi-chevron-down'} text-base sm:text-lg`}
                  style={{
                    color: '#2563ea',
                    transition: 'transform 0.3s ease',
                    transform: openIndex === 0 ? 'rotate(0deg)' : 'rotate(0deg)'
                  }}
                ></i>
              </div>
              <div
                className="accordion-content"
                style={{
                  maxHeight: openIndex === 0 ? '500px' : '0',
                  overflow: 'hidden',
                  transition: 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease-out',
                  padding: openIndex === 0 ? '0 1.25rem 1.25rem 1.25rem' : '0 1.25rem',
                  opacity: openIndex === 0 ? 1 : 0
                }}
              >
                <p className="m-0 text-sm sm:text-base" style={{ color: '#8ca2c1', lineHeight: '1.6' }}>
                  Ödemeniz onaylandığı anda seanslarınız Mobıthera uygulaması içindeki otomatik olarak yansıtılır.Hemen ilk randevunuzu alabilirsiniz
                </p>
              </div>
            </div>

            <div className="accordion-item" style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '0.75rem',
              border: '1px solid #e3e9f1',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
              overflow: 'hidden',
              transition: 'all 0.3s ease'
            }}>
              <div
                className="accordion-header flex justify-between items-center p-4 sm:p-5 cursor-pointer"
                onClick={() => toggleAccordion(1)}
                style={{
                  backgroundColor: openIndex === 1 ? '#f8f9fa' : '#FFFFFF',
                  transition: 'background-color 0.2s ease'
                }}
              >
                <p className="m-0 text-base sm:text-lg font-bold" style={{ color: '#2D3967' }}>
                  Satın aldığım seansların süresi var mı?
                </p>
                <i
                  className={`pi ${openIndex === 1 ? 'pi-chevron-up' : 'pi-chevron-down'} text-base sm:text-lg`}
                  style={{
                    color: '#2563ea',
                    transition: 'transform 0.3s ease'
                  }}
                ></i>
              </div>
              <div
                className="accordion-content"
                style={{
                  maxHeight: openIndex === 1 ? '500px' : '0',
                  overflow: 'hidden',
                  transition: 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease-out',
                  padding: openIndex === 1 ? '0 1.25rem 1.25rem 1.25rem' : '0 1.25rem',
                  opacity: openIndex === 1 ? 1 : 0
                }}
              >
                <p className="m-0 text-sm sm:text-base" style={{ color: '#8ca2c1', lineHeight: '1.6' }}>
                  Kampanyalı alınan 10'lu paketler 6 ay boyunca geçerlidir.Aktif Yaşam Paketi 12 ay boyunca geçerlidir.
                </p>
              </div>
            </div>

            <div className="accordion-item" style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '0.75rem',
              border: '1px solid #e3e9f1',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
              overflow: 'hidden',
              transition: 'all 0.3s ease'
            }}>
              <div
                className="accordion-header flex justify-between items-center p-4 sm:p-5 cursor-pointer"
                onClick={() => toggleAccordion(2)}
                style={{
                  backgroundColor: openIndex === 2 ? '#f8f9fa' : '#FFFFFF',
                  transition: 'background-color 0.2s ease'
                }}
              >
                <p className="m-0 text-base sm:text-lg font-bold" style={{ color: '#2D3967' }}>
                  İade politikası nedir?
                </p>
                <i
                  className={`pi ${openIndex === 2 ? 'pi-chevron-up' : 'pi-chevron-down'} text-base sm:text-lg`}
                  style={{
                    color: '#2563ea',
                    transition: 'transform 0.3s ease'
                  }}
                ></i>
              </div>
              <div
                className="accordion-content"
                style={{
                  maxHeight: openIndex === 2 ? '500px' : '0',
                  overflow: 'hidden',
                  transition: 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease-out',
                  padding: openIndex === 2 ? '0 1.25rem 1.25rem 1.25rem' : '0 1.25rem',
                  opacity: openIndex === 2 ? 1 : 0
                }}
              >
                <p className="m-0 text-sm sm:text-base" style={{ color: '#8ca2c1', lineHeight: '1.6' }}>
                  Kullanılmamış paketlerde 14 gün içinde koşulsuz iade hakkınız mevcutur.Seanslar kullanılmaya başladıktan sonra iade yapılmamaktadır.
                </p>
              </div>
            </div>

            <div className="accordion-item" style={{
              backgroundColor: '#FFFFFF',
              borderRadius: '0.75rem',
              border: '1px solid #e3e9f1',
              boxShadow: '0 2px 4px rgba(0, 0, 0, 0.05)',
              overflow: 'hidden',
              transition: 'all 0.3s ease'
            }}>
              <div
                className="accordion-header flex justify-between items-center p-4 sm:p-5 cursor-pointer"
                onClick={() => toggleAccordion(3)}
                style={{
                  backgroundColor: openIndex === 3 ? '#f8f9fa' : '#FFFFFF',
                  transition: 'background-color 0.2s ease'
                }}
              >
                <p className="m-0 text-base sm:text-lg font-bold" style={{ color: '#2D3967' }}>
                  Fizyoterapistler gerçek kişiler mi?
                </p>
                <i
                  className={`pi ${openIndex === 3 ? 'pi-chevron-up' : 'pi-chevron-down'} text-base sm:text-lg`}
                  style={{
                    color: '#2563ea',
                    transition: 'transform 0.3s ease'
                  }}
                ></i>
              </div>
              <div
                className="accordion-content"
                style={{
                  maxHeight: openIndex === 3 ? '500px' : '0',
                  overflow: 'hidden',
                  transition: 'max-height 0.3s cubic-bezier(0.4, 0, 0.2, 1), padding 0.3s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.25s ease-out',
                  padding: openIndex === 3 ? '0 1.25rem 1.25rem 1.25rem' : '0 1.25rem',
                  opacity: openIndex === 3 ? 1 : 0
                }}
              >
                <p className="m-0 text-sm sm:text-base" style={{ color: '#8ca2c1', lineHeight: '1.6' }}>
                  Evet,Mobıthera bünyesindeki tüm fizyoterapistler lisanslı ve alanında uzman personellerdir.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="w-full flex justify-center mt-6 sm:mt-8 md:mt-10">
        <div className="border-t w-4/5 sm:w-3/4 md:w-1/2" style={{ borderColor: '#e2e9f0' }}></div>
      </div>

      <div className="w-full flex flex-col items-center justify-center py-6 sm:py-8 md:py-10 gap-4 sm:gap-5 md:gap-6 px-4 sm:px-6" >
        <p className="m-0 text-lg sm:text-xl md:text-2xl font-bold text-center" style={{ color: '#2D3967' }}>Güvenlı Ödeme Altyapısı</p>
        <div className="flex items-center justify-center gap-2 sm:gap-3 md:gap-4 flex-wrap">
          <img src="/visaIcon.svg" className="w-12 sm:w-14 md:w-16 h-auto" alt="Visa" />
          <img src="/masterCardIcon.svg" className="w-12 sm:w-14 md:w-16 h-auto" alt="Mastercard" />
          <img src="/3dSecureIcon.svg" className="w-12 sm:w-14 md:w-16 h-auto" alt="3D Secure" />
          <img src="/iyzicoIcon.svg" className="w-12 sm:w-14 md:w-16 h-auto" alt="Iyzico" />
        </div>

        <div className="flex flex-col items-center justify-center gap-2 px-4">
          <p className="m-0 text-xs sm:text-sm text-center" style={{ color: '#8ca2c1' }}>@Mobithera Teknoloji A.Ş. Tüm hakları saklıdır.</p>
          <p className="m-0 text-xs sm:text-sm text-center" style={{ color: '#8ca2c1' }}>Satın alım yaparak Kullanıcı Sözleşmesi ve KVKK metinlerini kabul etmiş sayılırsınız.</p>
        </div>
      </div>

    </div>


  )
}

export default App

